export default __webpack_public_path__ + "static/media/CloudRain.c47f8511.svg";